import { html, css } from 'lit-element';
import { faVideo } from '@fortawesome/free-solid-svg-icons';
import { BaseElement } from './BaseElement';

import { PatientVideo as _PatientVideo } from '../PatientVideo';
import { DIALOG_TYPE_ERROR, DIALOG_TYPE_INFO } from './ModalDialog';
import { newGUID } from '../GUID';
import { API } from '../API';

import './VideoDialogContent';

const _video = Symbol();
const _api = Symbol();

class PatientVideo extends BaseElement {
	constructor() {
		super();

		this.library.add(faVideo);
	}
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				.container {
					display: flex;
					height: 100%;
					flex-flow: column nowrap;
				}
				.container > * {
					margin: 0.5em;
				}
				.container > .checkbox {
					flex: 1;
				}
			`
		];
	}
	get video() {
		return this[_video];
	}
	set video(v) {
		if(!(v instanceof _PatientVideo))
			throw new TypeError('video must be an instance of PatientVideo.');
		this[_video] = v;
	}
	get api() {
		return this[_api];
	}
	set api(v) {
		if(v !== null && !(v instanceof API))
			throw new TypeError('api must be an instance of API.');
		this[_api] = v;
	}
	get checked() {
		return this.shadowRoot.querySelector('input[type="checkbox"]').checked;
	}
	set checked(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('checked must be a boolean.');
		this.shadowRoot.querySelector('input[type="checkbox"]').checked = v;
	}
	async watch() {
		const id = newGUID();
		try {
			this.emit('show-busy', id);
			
			const data = await this.api.patientVideoData(this.video.patientVideoId);
			const url = this.window.URL.createObjectURL(data);

			this.emit('show-dialog', {
				title: this.video.name,
				contents: html`<pp-video-dialog-content .url="${url}"></pp-video-dialog-content>`,
				type: DIALOG_TYPE_INFO,
				width: 'auto'
			});

			this.emit('hide-busy', id);
		}
		catch(err) {
			this.emit('hide-busy', id);
			console.error(err);
			this.emit('show-dialog', {
				title: 'Watch Video Error',
				message: err.message,
				type: DIALOG_TYPE_ERROR
			});
		}
	}
	render() {
		return html`
			<div class="container">
				<div>
					<span class="checkbox">
						<input id="toggle" @change="${() => this.emit('check')}" type="checkbox" />
						<label for="toggle"></label>
					</span>
					<label for="toggle">${this.video.name}</label>
				</div>
				<button @click="${() => this.watch()}">
					<i class="icon fas fa-video"></i>
					Watch
				</button>
			</div>
		`;
	}
}

customElements.define('pp-patient-video', PatientVideo);